import React, { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import List from "./list";

const TabsExample = () => {

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Card className="main-card mb-3">
                    <CardBody>
                        <List />
                    </CardBody>
                </Card>
            </TransitionOnLoad>
        </Fragment>
    )
}
export default TabsExample
